import React, { useEffect, useState } from "react";
import Background from "../assets/teacher.svg";
import Navbar from "./Navbar";
import { Link, useNavigate } from "react-router-dom";
import { keyboard } from "@testing-library/user-event/dist/keyboard";
import SavingsDef from "./Education/SavingsDef";

export default function Invest({ user }) {
  let score = localStorage.getItem("answer");
  let portfolio = [{ Savings: 1 }, { Bonds: 7 }, { Stocks: 54 }];
  let portfolio_sorted = [];
  let values = [];

  if (
    portfolio[0].Savings > portfolio[1].Bonds &&
    portfolio[0].Savings > portfolio[2].Stocks
  ) {
    if (portfolio[1].Bonds > portfolio[2].Stocks) {
      portfolio_sorted.push(portfolio[0], portfolio[1], portfolio[2]);
      values.push(portfolio[0].Savings);
      values.push(portfolio[1].Bonds);
      values.push(portfolio[2].Stocks);
    } else {
      portfolio_sorted.push(portfolio[1], portfolio[2], portfolio[0]);
      values.push(portfolio[1].Bonds);
      values.push(portfolio[2].Stocks);
      values.push(portfolio[0].Savings);
    }
  } else if (
    portfolio[1].Bonds > portfolio[0].Savings &&
    portfolio[1].Bonds > portfolio[2].Stocks
  ) {
    if (portfolio[0].Savings > portfolio[2].Stocks) {
      portfolio_sorted.push(portfolio[1], portfolio[0], portfolio[2]);
      values.push(portfolio[1].Bonds);
      values.push(portfolio[0].Savings);
      values.push(portfolio[2].Stocks);
    } else {
      portfolio_sorted.push(portfolio[1], portfolio[2], portfolio[0]);
      values.push(portfolio[1].Bonds);
      values.push(portfolio[2].Stocks);
      values.push(portfolio[0].Savings);
    }
  } else if (
    portfolio[2].Stocks > portfolio[0].Savings &&
    portfolio[2].Stocks > portfolio[1].Bonds
  ) {
    if (portfolio[0].Savings > portfolio[1].Bonds) {
      portfolio_sorted.push(portfolio[2], portfolio[0], portfolio[1]);
      values.push(portfolio[2].Stocks);
      values.push(portfolio[0].Savings);
      values.push(portfolio[1].Bonds);
    } else {
      portfolio_sorted.push(portfolio[2], portfolio[1], portfolio[0]);
      values.push(portfolio[2].Stocks);
      values.push(portfolio[1].Bonds);
      values.push(portfolio[0].Savings);
    }
  }

  console.log("asda", values);

  const navigate = useNavigate();
  const goInvestPage = () => {
    navigate("/investpage");
  };

  const goSpecificInvest = (equity) => {
    console.log(typeof(equity[0]));
    navigate("/specificinvest", { state: { option: equity[0] } });
  };

  function perc2color(perc) {
    perc = perc - 100;
    perc = Math.abs(perc)
    var r,
      g,
      b = 0;
    if (perc < 50) {
      r = 255;
      g = Math.round(5.1 * perc);
    } else {
      g = 255;
      r = Math.round(510 - 5.1 * perc);
    }
    var h = r * 0x10000 + g * 0x100 + b * 0x1;
    return "#" + ("000000" + h.toString(16)).slice(-6);
  }

  return (
    <div className="w-screen overflow-hidden">
      <Navbar user={user} />

      <div className="grid grid-cols-5 g-3 ">
        <div className="col-span-2">
          <div className="font-sans font-bold text-[#636B90] text-3xl ml-8 flex justify-center items-center mt-10">
            FinGen Calculated Score
          </div>
          <div
            className="font-sans font-bold text-3xl ml-8 flex justify-center items-center"
            style={{ color: perc2color(score) }}
          >
            {score}
          </div>
          {/* <span className="lg:inline-block font-sans font-bold text-1xl text-[#000000] pb-4 ml-4">
            based on risk tolerance and term
          </span> */}

          <div className="font-sans font-bold text-[#636B90] text-3xl ml-8 flex justify-center items-center mt-10">
            Recommended Investments
          </div>

          <button
            className="border-black border-2 h-12 w-[70%]  mr-[10%] ml-[17%] pt-8 pb-24 rounded-3xl align-middle mt-4 hover:cursor-pointer  hover:border-[#73C4FC] hover:border-4"
            onClick={ () =>{goSpecificInvest(Object.keys(portfolio_sorted[0]))} }
          >
            <div className="grid grid-cols-2 g-3 ">
              <div className="text-4xl text-[#000000] mt-2 ml-[20%] font-sans lg:inline-block ">
                {Object.keys(portfolio_sorted[0])}
              </div>
              <div
                className="font-sans font-bold mr-[25%] text-6xl text-[#008000] text-right lg:inline-block"
                style={{ color: perc2color(values[0]) }}
              >
                {values[0]}
              </div>
            </div>
          </button>

          <button
            className="border-black border-2 h-12 w-[70%]  mr-[10%] ml-[17%] pt-8 pb-24   rounded-3xl align-middle mt-4 hover:cursor-pointer hover:border-[#73C4FC] hover:border-4"
            onClick={ () =>{goSpecificInvest(Object.keys(portfolio_sorted[1]))} }
          >
            <div className="grid grid-cols-2 g-3 ">
              <div className="text-4xl text-[#000000] mt-2 ml-[20%] font-sans lg:inline-block ">
                {Object.keys(portfolio_sorted[1])}
              </div>
              <div
                className="font-sans font-bold mr-[25%] text-6xl text-[#008000] text-right lg:inline-block"
                style={{ color: perc2color(values[1]) }}
              >
                {values[1]}
              </div>
            </div>
          </button>

          <button
            className="border-black border-2 h-12 w-[70%]  mr-[10%] ml-[17%] pt-8 pb-24   rounded-3xl align-middle mt-4 hover:cursor-pointer hover:border-[#73C4FC] hover:border-4"
            onClick={ () => {goSpecificInvest(Object.keys(portfolio_sorted[2]))}}
          >
            <div className="grid grid-cols-2 g-3 ">
              <div className="text-4xl text-[#000000] mt-2 ml-[20%] font-sans lg:inline-block ">
                {Object.keys(portfolio_sorted[2])}
              </div>
              <div
                className="font-sans font-bold mr-[25%] text-6xl text-[#008000] text-right lg:inline-block"
                style={{ color: perc2color(values[2]) }}
              >
                {values[2]}
              </div>
            </div>
          </button>
        </div>
        <div className="col-span-3 ">
          <div class="h-auto max-w-full rounded-lg lg:inline-block pt-16">
            <img src={Background} alt="..." class="bg-fill height-auto" />
          </div>
        </div>
      </div>

      {/* <span className="w-1/3 lg:inline-block flex">
        
        
        

        

        <div
          className="border-black border-2 h-12  pt-8 pb-24 rounded-3xl align-middle mt-4 hover:cursor-pointer "
          onClick={goSpecificInvest}
        >
          <div className="text-3xl pl-8 text-[#000000] font-sans lg:inline-block ">
            Bonds
          </div>
          <div className="font-sans font-bold pl-64 text-6xl text-[#008000] text-right lg:inline-block">
            5
          </div>
        </div>
        <div
          className="border-black border-2 h-12  pt-8 pb-24 rounded-3xl align-middle mt-4 hover:cursor-pointer"
          onClick={goSpecificInvest}
        >
          <div className="text-3xl pl-8 text-[#000000] font-sans lg:inline-block ">
            Stocks
          </div>
          <div className="font-sans font-bold pl-64 text-6xl text-[#008000] text-right lg:inline-block">
            5
          </div>
        </div>
        <div
          className="border-black border-2 h-12  pt-8 pb-24 rounded-3xl align-middle mt-4 hover:cursor-pointer"
          onClick={goSpecificInvest}
        >
          <div className="text-3xl pl-8 text-[#000000] font-sans lg:inline-block ">
            Savings
          </div>
          <div className="font-sans font-bold pl-64 text-6xl text-[#008000] text-right lg:inline-block">
            5
          </div>
        </div>
      </span> */}
      {/* <div class="h-auto max-w-full rounded-lg lg:inline-block">
        <img src={Background} alt="..." class="bg-fill height-auto" />
      </div> */}
    </div>
  );
}
